import React from 'react';
import { Page } from '../Page';
export function PageBrainSide() {
  return <Page pageNumber={4} variant="light" data-id="element-1065">
      <div className="flex flex-col h-full" data-id="element-1066">
        <div className="mb-4 pt-4" data-id="element-1067">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1068">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1069">
            GLP-1 And <span className="text-tealslate" data-id="element-1070">The Brain</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mb-4" data-id="element-1071" />
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1072">
            How the medication rewires your reward system and relationship with
            food.
          </p>
        </div>

        <p className="text-[10px] text-[#7A7A70] tracking-wider font-bold mb-1" data-id="element-1073">
          <em data-id="element-1074">Figure 2</em>
        </p>
        <div className="flex-1 -mx-12 px-12 flex flex-col justify-center" data-id="element-1075">
          <div className="flex justify-center" data-id="element-1076">
            <img src="https://cdn.magicpatterns.com/uploads/aL8CWLBGxDYU95eu597Ee5/Picture1.png" alt="Brain diagram showing how GLP-1 medication affects appetite centers, reward pathways, and the hypothalamus" className="h-[560px] object-contain" data-id="element-1077" />
          </div>
        </div>

        <div className="pt-4" data-id="element-1078">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1079">
            <strong className="text-[#1F1F1F]" data-id="element-1080">How it works:</strong>{' '}
            <em data-id="element-1081">
              GLP-1 receptors in the brain's appetite and reward centers reduce
              food noise, dampen dopamine spikes from processed foods, and
              signal satisfaction. The result: fewer cravings and more control
              over what you eat.
            </em>
          </p>
        </div>
      </div>
    </Page>;
}